<div class="container-fluid modal-style">
  <div class="row">
    <div class="col-md-12 icon-wrapper" (click)="close()">
      <img src="assets/icons/close.svg" />
    </div>
  </div>
  <div class="row text-area">
    <div class="col-md-12 inner-style">
      <span class="text-style" style="color: #fff; font-weight: 600; font-size: 16px"
        >{{ header }}!</span
      >
    </div>
  </div>
  <div class="row text-area">
    <div class="col-md-12 inner-style">
      <span class="text-style">{{ text }}</span>
    </div>
  </div>
  <div class="row button-area">
    <div class="col-md-12" style="display: flex">
      <p-button class="button-style" severity="primary" (click)="ok()">
        {{ 'general.ok' | translate }}
      </p-button>
    </div>
  </div>
</div>
